module.exports = __webpack_public_path__ + "static/img/boxed_bg_retina.047458c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/backgrounds/boxed_bg_retina.png
// module id = 1kIq
// module chunks = 150